import { CustomsStateNotificationType, Transit, TransitStatus } from '@e-origin/shared';

export const countCustomsStateNotifications = (transit: Transit): { notificationsPending: number } => {
  const notificationsPending =
    transit.customsState?.notifications?.filter(({ notificationType, read }) => notificationType === CustomsStateNotificationType.NOTIFICATION_PENDING && !read)
      .length ?? 0;

  return { notificationsPending };
};

export const canTransitBeAmended = (transit: Transit): boolean => {
  return [TransitStatus.ACCEPTED, TransitStatus.GUARANTEE_NOT_VALID].includes(transit.generalInfo.status);
};

export const getTransitDuplicationModalTitle = (transit: Transit): string => {
  if (canTransitBeAmended(transit)) {
    return 'Amendment or Duplication';
  }

  return 'Duplication';
};
